import { Menu as BaseMenu } from 'antd';

// @note: previously we had it wrapped to our component but it seems I missed something and it did not work well

export const Menu = BaseMenu;

export default Menu;
